"use strict";

document.addEventListener("DOMContentLoaded", function () {
  (function selectActions() {
    var selects = document.querySelectorAll(".omd-select:not(.omd-select.js-no-location)");
    if (selects.length) {
      selects.forEach(function (item) {
        var dataUrl = item.dataset.url;
        item.addEventListener("change", function () {
          if (!window.location.href.includes("".concat(dataUrl).concat(item.name, "=").concat(item.value))) {
            window.location.href = "".concat(dataUrl).concat(item.name, "=").concat(item.value);
            window.open(window.location.href);
          }
        });
      });
    }
  })();
});